<template>
  <div class="feedback-content">
    <Button
      color="green"
      full
      :invert="currentSelection !== Selections.SOMETHING_DOESNT_MAKE_SENSE"
      @click="handleSelection(Selections.SOMETHING_DOESNT_MAKE_SENSE)"
      >Something doesn't make sense</Button
    >
    <Button
      color="green"
      full
      :invert="currentSelection !== Selections.HUMAN_SENSE_CHECK"
      @click="handleSelection(Selections.HUMAN_SENSE_CHECK)"
      >I want a human sense-check before moving forward</Button
    >
    <Button
      color="green"
      full
      :invert="currentSelection !== Selections.ASK_SOMETHING_ELSE"
      @click="handleSelection(Selections.ASK_SOMETHING_ELSE)"
      >Something else</Button
    >
    <Button color="red" @click="handleAskSomethingElseNext" :disabled="!currentSelection">Continue in messages</Button>
    <span class="feedback-content__cancel" @click="emits('go-to-stage', Stages.DEFAULT)">Back</span>
  </div>
</template>

<script setup lang="ts">
import { SelectionForStage, Stages } from './types'
import { ref } from 'vue'
import { Selections } from './types'
import { useAuthUserState } from 'app/javascript/src/stores'
import { useTypedItineraryStore } from 'app/javascript/src/stores/typed'
import { Product } from 'app/javascript/src/models'
import api from 'app/javascript/src/utils/api'
import { redirectTo } from 'app/javascript/src/utils/functions'
import Button from '@/components/Theme2/Button.vue'

const emits = defineEmits<{
  (e: 'go-to-stage', stage: Stages): void
}>()
const itineraryStore = useTypedItineraryStore<Product>()
const userAuth = useAuthUserState()

const currentSelection = ref<SelectionForStage<Stages.ASK_SOMETHING_ELSE> | null>(null)

const handleSelection = (selection: SelectionForStage<Stages.ASK_SOMETHING_ELSE>) => {
  if (currentSelection.value === selection) {
    currentSelection.value = null
  } else {
    currentSelection.value = selection
  }
}
const handleAskSomethingElseNext = async () => {
  if (!itineraryStore.data) {
    return
  }

  try {
    await api.post(`/api/chatrooms/${itineraryStore.chatroomId}/messages/self_serve_message`, {
      selections: [currentSelection.value],
      sender_name: userAuth.name.value,
    })

    redirectTo(`/travelers/messages?itineraryRequestId=${itineraryStore.data.itineraryRequestId}`)
  } catch (error) {
    console.error(error)
  }
}
</script>
